<template>
    <div res="insertWebLinkDialog" id="insertWebLinkDialog" class="mask" v-show="show">
        <div id="dialogContent" class="center">
            <div id="linkUrl" class="item">
                <span>連結:</span>
                <input id="webLinkUrlInput" v-model="webLinkUrlInput" type="text" placeholder="https://www.example.com" @input="checkUrlLength" />
            </div>
            <p class="prompt" v-show="showUrlPrompt" >{{urlEmptyPrompt}}</p>
            <div id="linkName" class="item">
                <span>名稱:</span>
                <input id="webLinkNameInput" v-model="webLinkNameInput" type="text" placeholder="插入網頁" @input="checkLinkName">
            </div>
            <p class="titleLimit" v-show="showTitleLimit" >{{overTitleLimit}}</p>
            <div id="buttons" class="item">
                <div id="delete" v-on:click="deleteWebLink">
                    <img src="../assets/other_tools/common/delete.svg" alt="">
                    <text>刪除</text>
                </div>
                <div id="confirm" @click="confirmWebLink">
                    <img src="../assets/other_tools/common/confirm.svg" alt="">
                    <text>確認</text>
                </div>
            </div>
        </div>
    </div>
    <ConfirmDialog ref="confirmDialog" />
</template>

<script>

import ConfirmDialog from '../components/dialogs/ConfirmDialog.vue'
import { Text } from 'vue';
import { DEBOUNCE } from '../js/common/debounce';
import { CHECK_INPUT_CHAR } from '../js/common/check_char';

export default {
    components: { ConfirmDialog, Text },
    name: "app",
    data: function () {
        return {
            curSelectGroup: null,
            webLinkUrlInput: "",
            webLinkNameInput: "",
            show: false,
            urlEmptyPrompt: "網址不能空白",
            overTitleLimit: "限10字元",
            showUrlPrompt: false,
            showTitleLimit: false,
            checkUrlLength: null,
            checkLinkName: null,
            linkNmaeLimit: 10
        };
    },
    methods: {
        confirmWebLink() {
            console.log("確認");

            this.webLinkNameInput = CHECK_INPUT_CHAR(this.webLinkNameInput, 10).substringStr;

            if(this.webLinkUrlInput.length == 0) {
                this.showUrlPrompt = true;
                return;
            }
            //抓取畫布所點選的超連結更新資料
            this.curSelectGroup.updateData(this.curSelectGroup, this.webLinkUrlInput, this.webLinkNameInput);

            this.show = false;
            this.curSelectGroup = null;
        },
        deleteWebLink() {
            console.log("刪除");

            this.$refs.confirmDialog.showDialog("警告", "確定要刪除嗎？", () => {
                // 抓取畫布所點選的超連結 並且刪除
                this.curSelectGroup.remove();

                this.show = false;
                this.curSelectGroup = null;
            }, () => { }, "刪除");


        },
        setWebLinkData(newGroup, newUrl, newName) {
            this.curSelectGroup = newGroup;
            this.webLinkUrlInput = newUrl;
            this.webLinkNameInput = newName;
            this.showUrlPrompt = false;
            this.showTitleLimit = false;
        },
        showView(visible) {
            this.show = visible;
        },
        openUrl: function (callback) {
            callback(this.webLinkUrlInput);
        }
    },
    mounted: function () {
        const self = this;
        window.insertWebLinkDialog = this;

        this.checkUrlLength = DEBOUNCE(() => {
                console.log("trigger debounce");
                if(self.webLinkUrlInput.length != 0) {
                    self.showUrlPrompt = false;
                }
            })

        this.checkLinkName = (e) => {
            let checkChar = CHECK_INPUT_CHAR(self.webLinkNameInput, 10);

            if (checkChar.pass) {
                self.showTitleLimit = false;
            } else {
                self.showTitleLimit = true;
                self.webLinkNameInput = checkChar.substringStr;
            }
        };
    }
}
</script>

<style scoped>
#insertWebLinkDialog {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: var(--z-index-insert-web-link);
}

#insertWebLinkDialog #dialogContent {
    width: 37.5em;
    height: 21.8em;
    background-color: white;
    border: rgb(0, 102, 203) 4px solid;
    border-radius: 1.6em;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    flex-wrap: nowrap;
}

#insertWebLinkDialog #dialogContent .item {
    height: fit-content;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    flex-wrap: nowrap;
    margin-top: 1em;
}
.prompt {
    color: red;
    font-weight: normal;
    font-size: 1em;
    width: 100%;
    line-height: 1em;
    position: fixed;
    top: 100px;
}

.titleLimit {
    color: red;
    font-weight: normal;
    font-size: 1em;
    width: 100%;
    line-height: 1em;
    position: fixed;
    top: 200px;
}

#insertWebLinkDialog #dialogContent span {
    font-weight: bold;
    font-size: 1.5em;
    margin-left: 1.3em;
    width: 3.75em;
    line-height: 1.5em;
}

#insertWebLinkDialog #dialogContent input {
    flex-grow: 2;
    flex-basis: 50%;

    font-size: 1em;

    text-align: center;

    margin-left: 1em;
    margin-right: 4em;

    border: 0.1px solid;
    border-radius: 0.4em;
}



/* 
#insertWebLinkDialog #dialogContent #buttons {
  width: 100%;
  height: 100%;
} */

/* #insertWebLinkDialog #dialogContent #buttons div {
   width: 3.75em;
  height: 3.75em;
  background-size: contain;
  margin-right: 3.75em;
  margin-left: 3.75em;
  cursor: pointer;
}
 */
/* #insertWebLinkDialog #dialogContent #buttons>#delete {
  background-image: url("../assets/other_tools/common/delete.svg");

}

#insertWebLinkDialog #dialogContent #buttons>#confirm {
  background-image: url("../assets/other_tools/common/confirm.svg");
} */

#insertWebLinkDialog #dialogContent #buttons>div>text {
    position: relative;
    top: -0.4em;
    font-size: 1.6em;
}
</style>